import {
  name
} from "./chunk-IBL4GUA3.js";

// src/macros.ts
var maybe = (_) => {
  throw Error(
    [
      `${name}: unreplaced macro`,
      "",
      `Did you forget to add the '${name}' plugin to your Vite config?`,
      "\u{1F449} https://github.com/pcattori/vite-env-only#install"
    ].join("\n")
  );
};
var serverOnly$ = maybe;
var clientOnly$ = maybe;
export {
  clientOnly$,
  serverOnly$
};
